import Content from "./field-content.svelte"
import Description from "./field-description.svelte"
import Error from "./field-error.svelte"
import Group from "./field-group.svelte"
import Label from "./field-label.svelte"
import Legend from "./field-legend.svelte"
import Message from "./field-message.svelte"
import Separator from "./field-separator.svelte"
import Set from "./field-set.svelte"
import Title from "./field-title.svelte"
import Field from "./field.svelte"

export {
  Field,
  Set,
  Legend,
  Group,
  Content,
  Label,
  Title,
  Description,
  Separator,
  Error,
  Message,
  //
  Set as FieldSet,
  Legend as FieldLegend,
  Group as FieldGroup,
  Content as FieldContent,
  Label as FieldLabel,
  Title as FieldTitle,
  Description as FieldDescription,
  Separator as FieldSeparator,
  Error as FieldError,
  Message as FieldMessage,
}
